<template>
    <v-layout column>
        <v-flex v-if="hasPlans" xs12>
            <div  class="container-membership app-choose-plan align-center elevation-0" >
                <div class="info-mem-free">
                    <div class="_details-price">
                        <p class="main-title">Free Membership</p>
                        <div class="free-pricing-info"><p>$0</p></div>
                        <p class="sub-title">Limited functionality so you can take a peek at what’s in store at NannyGranny</p>
                        <span>Browse NannyGrannies in your area, and when you’re ready to connect directly, upgrade to a full membership to shortlist, contact, and ultimately find your NannyGranny. </span>
                    </div>
                    <div class="action-btn">
                        <v-btn :loading="loading"
                            class="ma-0 primary v-btn--default elevation-0"
                            @click="submitfree">
                            Continue for free
                        </v-btn>
                    </div>
                </div>
 
                <div class="info-mem-full" v-if="item.id==default_signup_method" v-for="item in plans">
                    <div class="_details-price">
                        <div class="main-title-full">Full Membership</div>
                        <span class="tag-line"><strong>Intro Offer:</strong> Save 25%</span>
                        <div class="full-pricing-info"><p class="striketrough">$65</p><p class="formainprice">${{Math.round(item.price)}}</p></div>
                        <p class="sub-title-monthly">for {{item.invoice_period}} months, then just $6.70 per month <br>(cancel anytime)</p>
                        <p class="sub-title-full">Everything you need to hire your NannyGranny</p>
                        <span>Join now for access to our full database of NannyGrannies. Filter by your preferences, make a shortlist of your favourites, and chat directly to find your NannyGranny now.</span>
                        <ul class="listoptions">
                            <li>Unlimited access to contact our database of Australia’s most experienced domestic carers</li>
                            <li>Access to lifestyle and ClubHouse content </li>
                            <li>Only <del>$65</del> ${{Math.round(item.price)}} for three months, then automatically maintain your access for $6.70 per month</li>                  
                        </ul>
                    </div>
                    <div class="action-btn-join">
                        <v-btn :loading="loading"
                            class="ma-0 primary v-btn--default elevation-0"
                            @click="submit(`${item.id}`)">
                            Join now
                        </v-btn>
                    </div>
                </div>

            </div>
        </v-flex>

    </v-layout>
</template>

<script>
import { DEFAULT_SIGNUP_OPT,MAIN_SIGNUP_PLANS_OPT } from '../../config/constants'
  export default {
    name: 'app-btn-toggle-plan-reg',
    filters: {
      savePer: function (item) {
        return (100 - parseInt(parseFloat(item.price_all) * 100 / parseFloat(item.price)))
      }
    },

    props: {
      value: Number,
      showvalidplans: null,
      mandatory: {
        type: Number,
        default: 1
      },
      hideDescription: Boolean
    },

    data () {
        
      return {
        select: null,
        default_signup_method: DEFAULT_SIGNUP_OPT,
        //show_signup_method: showvalidplans,
      }
    },

    computed: {
        
      hasPlans () {
        return this.$store.getters['subscription/hasPlans']
      },
     
      plans () {
        let plans= this.$store.getters['subscription/plans']
        if (typeof this.showvalidplans !== 'undefined') {
           
          const matchedElements = plans.filter(item1 => {
            return this.showvalidplans.find(item2 => item2 === item1.id);
          });
          return matchedElements
        }
        else{
            const matchedElements = plans.filter(item1 => {
            return this.default_signup_method.find(item2 => item2 === item1.id);
            });
            return matchedElements
        }

        
      }
    },

    watch: {
    
      select () {
       
        this.$store.commit('subscription/SET_PLAN', this.select)
        if (this.select) {
          this.$emit('input', this.select.id)
        }
      },
      currentPlan (plan) {
        let price = this.$lodash.get(plan, 'price_all', 0)
        this.form.summ = price ? price : this.$lodash.get(plan, 'price', 0)
      }
    },

    mounted () {
        
      if (this.hasPlans) {
        this.select = this.plans[this.mandatory]
      }
    },

    methods: {
        
      isSave: function (item) {
        return parseInt(item.price) !== parseInt(item.price_all) && !isNaN(item.price_all) && parseInt(item.price_all) > 0
      },
      submit (plan_id) {
        let plans =  this.$store.getters['subscription/plans']
        console.log(plans);
        var i;
        plans.forEach(function(x, index) {
            if (x.id == plan_id) {
                i = index;
            }
        });
        this.$store.commit('subscription/SET_PLAN', plans[i])
         this.$store.dispatch('register/STEP_2', {data: this.user})
          .then(() => (this.$router.push('/signup/step-3/parent')))
          .catch(error => (console.log(error)))
      },
      submitfree () {
        this.$router.push('/signup/step-3/parent-free')
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .striketext
        text-decoration line-through    
    .action-btn
        width 100%
        .v-btn
            width 50%
            height auto !important
            position absolute
            bottom 5%
            left 27%
    .action-btn-join
        width 100%
        .v-btn
            width 50%
            height auto !important
            position absolute
            bottom 5%
            left 27%
            background #039E8B !important
    ._details-price
        .sub-title-full
            font-weight bold
            font-size 16px
            margin 0 9% 0% 9%
        .sub-title
            font-weight bold
            font-size 16px
            margin 0 9% 4% 9%
        .sub-title-monthly
            font-weight bold
            font-size 16px
            color #039E8B
        .listoptions
            text-align left
            margin 10px 0 0 25px
        .main-title
            font-size 28px
            margin-top 34px
            color #4D4DFF
            font-weight bold
        .main-title-full
            font-size 28px
            margin-top 34px
            color #039E8B
            font-weight bold
        .full-pricing-info
            
            height 85px
            margin 15px 30% 0 30%
            width 100%

            .formainprice
                font-size 36px
                font-weight bold
                color #fff
                margin-left 13px
                float left
                background-image: url(../../assets/img/full-pricing-info.svg);
                width 96px
            .striketrough
                text-decoration line-through
                color #F56225
                font-size 36px
                font-weight bold
                float left
        .free-pricing-info
            background-image: url(../../assets/img/free-pricing-info.svg);
            height 85px
            margin 33px 38% 0px 38%
            p
                font-size 36px
                font-weight bold
                color #fff
                margin-left -13px
        span
            font-size 16px
            color #000   
            display inline-block
            width 93%
        .tag-line 
            text-align center
            font-size 16px
            color #039E8B
    .container-membership
        background #fff
        gap 20px
        margin 20px 0
    .info-mem-full
        background-image: url(../../assets/img/full-membership.svg);
        width 91%
        height 610px
        @media only screen and (min-device-width : 320px) and (max-device-width : 480px)
            width auto
        position relative
        margin auto
        background-size 100% 100%
    .info-mem-free
        background-image: url(../../assets/img/free-membership.svg);
        width 91%
        @media only screen and (min-device-width : 320px) and (max-device-width : 480px)
            width auto
        height 610px
        position relative
        margin auto
        background-size 100% 100%
    .dollarsign
        color #000
    .numbercolor
        color var(--blue)
    .app-choose-plan
        display flex
        flex-direction column
        width 100%
        background-color transparent !important
        .v-btn
            height auto
            background-color #ffffff
            opacity 1
            padding 0
            &:before
                content none
            &:first-child
                transform translateY(2px)
            &:last-child
                transform translateY(-2px)
            ._v-btn-description
                position absolute
                top -2px
                left -2px
                right -2px
                height 34px
                line-height 34px
                background var(--blue)
                color #fff
                font-size 1rem
            ._invoice-per
                margin-bottom 12px
            ._v-btn-content
                width 100%
                
                padding 15px 16px 16px
                transition all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
                &._with-description
                    height 190px
                    padding 65px 16px 16px
                .rounded--brand
                    width 38px
                    height 39px
                    background-color var(--green)
                    color #ffff
                    font-size 24px
                    line-height 42px
                    margin auto
                    & ~ span
                        font-size 18px
                        text-transform capitalize
                ._details-price
                    > div
                        display: inline-block
                ._price-all
                    text-decoration line-through
                    color var(--charcoal)
        .v-btn--active
            width auto
            background-color #fff
            ._v-btn-content
                h3, span
                    color #fff
                .rounded--brand
                    background-color #fff
                    color var(--blue)
                ._details-price
                    color #fff
                .plan_description
                    color #fff

    .plan_description
        font-size 13px
        white-space normal
    ._description
        margin-top 10px

    @media (min-width: 600px)
        .app-choose-plan
            min-height 304px
            flex-direction row
            .v-btn
                &:first-child
                    transform translateX(2px)
                &:last-child
                    transform translateX(-2px)
                ._v-btn-content

                    display flex
                    flex-direction column
                    justify-content space-between
                    padding-bottom 20px
                    &._with-description
                        height 200px
                        padding 35px 16px 20px
                    ._details-price
                        > div
                            display: block
                ._v-btn-description
                    background transparent
                    top -16px
                    ._text
                        display inline-block
                        background var(--blue)
                        padding 0 16px
            .v-btn--active
                width 100%
               
                        
                        

    @media (min-width: 960px)
        .app-choose-plan
            .v-btn
                width auto
                height 290px
                padding 8px 0
                border 0px !important
                ._v-btn-content
                    height 290px
                    .rounded--brand
                        width 62px
                        height 63px
                        font-size 38px
                        line-height 65px
                    &._with-description
                        height 290px
            .v-btn--active
                width 258px
    @media (min-width : 320px)  and (max-width: 480px)
        .info-mem-free
            position relative
            width auto !important
            margin auto
            height auto !important
            background-size 100% 100%
            border 1px solid  #4d4dff !important
            border-radius 15px
            background-image none !important
            .action-btn 
                margin-top 10px
                .v-btn
                    position relative
                    padding 10px 0
                    left 0
                .v-btn--default
                    min-width auto
        .info-mem-full
            width auto !important
            position relative
            margin auto
            height auto !important
            background-size 100% 100%
            border 1px solid var(--green) !important
            border-radius 15px
            background-image none !important
            .action-btn-join
                margin-top 10px
                .v-btn
                    position relative
                    padding 10px 0
                    left 0
                .v-btn--default
                    min-width auto
</style>



// WEBPACK FOOTER //
// src/components/app-buttons/app-btn-toggle-plan-reg.vue